<template>
  <div class="scoreList">
    <img src="/statics/images/jifen/head.png" class="titleImg" />
    <!-- <img src="@/assets/img/head.png" class="titleImg" /> -->
    <div class="titleImgName">《北京市居住证》积分模拟打分计算器</div>
    <div class="titleText">
      <p class="text">
        依据《北京市积分落户管理办法》新政策条例模拟计算居住证积分
      </p>
      <p class="prompt">
        请选择符合您情况的选项或在文本框中填写相应的数字、内容，完成测分后将获得准确积分结果。
      </p>
      <div class="divTitle">
        <a href="https://www.bjmzw.com/bjluxt/" class="list">
          <div class="num">1</div>
          <div class="name">基础指标</div>
        </a>
        <a href="https://www.bjmzw.com/bjluxt/" class="list">
          <div class="num">2</div>
          <div class="name">加分指标</div>
        </a>
        <a href="https://www.bjmzw.com/bjluxt/" class="list">
          <div class="num">3</div>
          <div class="name">减分指标</div>
        </a>
        <div class="lists">
          <div class="num">4</div>
          <div class="name">积分评估</div>
        </div>
        <div class="list">
          <div class="num">5</div>
          <div class="name">测评分析</div>
        </div>
      </div>
      <div class="content">
        <div class="titleName">模拟积分结果</div>
        <div class="totalScore">
          总分共计：
          <div class="number">{{scoreNum}}</div>
          分
        </div>
        <table>
          <thead>
            <tr>
              <th>序号</th>
              <th>积分项目明细</th>
              <th>分值</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in scoreList" :key="index">
              <td>{{index + 1}}</td>
              <td>{{item.target}}</td>
              <td v-if="item.id != 23">{{item.num}}</td>
              <td v-else-if="scoreList.length > 1">否</td>
              <td v-else-if="scoreList.length = 1">是</td>
              <td v-else>{{item.num}}</td>
            </tr>
          </tbody>
        </table>
        <div class="bottomText">
          本系统依据《北京市居住证积分管理指标体系》进行模拟模拟测算，测算结果仅供参考。申请人最终积分以实际审核结果为准。
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import scoreList from "@/assets/json/scoreList.json";
export default {
  data() {
    let config = [];
    Object.assign(config, scoreList);
    return {
      tbodyList: config,
      scoreList:[],
      scoreNum:0
    };
  },
  mounted() {
    if (localStorage.getItem("beijinScore")) {
      this.scoreList = JSON.parse(localStorage.getItem("beijinScore"));
      this.numContent()//赋值积分
      this.score()//运算积分
      this.stySplit()//拼接字符
    }
  },
  methods:{
    numContent(){
      this.tbodyList.forEach(item => {
        this.scoreList.forEach((i) => {
          if(i.scoreId == item.id){
              item.num = i.num
          }
        })
      })
    },
    score(){
      let that = this
      if(this.scoreList.length != 0){
        this.scoreList.forEach((item) => {
          that.scoreNum = that.scoreNum + Number(item.num)
          
        })
      }
      // this.scoreNum
    },
    stySplit(){
      let str = ''
      this.scoreList.forEach(item => {
        str = str + item.id + item.target + item.num + "\n"
      })
      sessionStorage.setItem('beijingSty',str)
    }
  },
};
</script>
<style lang="less" scoped>



.scoreList {
  width: 1180px;
  margin: 0 auto;
  position: relative;
  left: 0;
  top: 0;
  .titleImg {
    width: 100%;
    height: 120px;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 55;
  }
  .titleImgName{
    width: 100%;
    height: 120px;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 56;
    line-height: 120px;
    text-align: center;
    color: #ffffff;
    font-weight: bold;
    font-size: 42px;
  }
  .titleText {
    font-size: 14px;
    width: 100%;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    padding-top: 162px; 
    position: relative;
    z-index: 60;
    text-decoration:none;
    text-align: center;
    // top: 162px;
    .text {
      text-align: center;
      width: 896px;
      margin: 0 auto;
    }
    .prompt {
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #de0a37;
      height: 14px;
      line-height: 14px;
      margin-top: 8px;
    }
  }
  .divTitle {
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    margin-top: 54px;
    .list {
      width: 200px;
      height: 52px;
      background: #ffffff;
      border: 1px solid #1586dd;
      border-radius: 26px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      text-decoration:none;
      .num {
        width: 36px;
        height: 36px;
        background: #1586dd;
        border-radius: 50%;
        font-size: 22px;
        line-height: 36px;
        text-align: center;
        // margin-left: 8px;
        color: #ffffff;
      }
      .name {
        height: 18px;
        font-size: 18px;
        color: #1586dd;
        line-height: 19px;
        margin-left: 10px;
        width: 148px;
        text-align: center;
        // flex: 1;
        // text-align: center;
      }
    }
    .lists {
      width: 200px;
      height: 52px;
      background: #1586dd;
      border: 1px solid #1586dd;
      border-radius: 26px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      .num {
        width: 36px;
        height: 36px;
        color: #1586dd;
        border-radius: 50%;
        font-size: 22px;
        line-height: 36px;
        text-align: center;
        // margin-left: 8px;
        background: #ffffff;
      }
      .name {
        height: 18px;
        font-size: 18px;
        color: #ffffff;
        line-height: 19px;
        margin-left: 10px;
        width: 148px;
        text-align: center;
        // flex: 1;
        // text-align: center;
      }
    }
  }
  .content {
    width: 1140px;
    margin: 0 auto;
    margin-top: 40px;
    border: 1px solid #F1F1F1;
    // position: relative;
  }
  .bottomText{
    width: 1140px;
    height: 60px;
    background: #EEF8FF;
    margin-top: 40px;
    line-height: 60px;
    font-size: 16px;
    color: #1E91E9;
    text-align: center;
  }
  .titleName {
    background: #1586dd;

    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
   
    padding: 23px 0 20px 19px;
  }
  .totalScore{
    padding: 39px 0;
    display: flex;
    justify-content: center;
    align-items:  flex-end;
    font-size: 20px;
    color: #999999;
    
  }
  .number{
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #F6252F;
    height: 36px;
    line-height: 36px;
  }
  table {
    width: 1100px;
    margin: 0 20px;
    text-align: center;
    border-collapse: collapse;
    tr {
      td,
      th {
        height: 50px;
        line-height: 50px;
      }
    }
    thead {
      tr {
        th {
          background: #0168b7;
          font-weight: bold;
          color: #ffffff;
          font-size: 18px;
          border: 1px solid #ffffff;
        }
      }
    }
    tbody {
      tr {
        td {
          border: 1px solid #0168b7;
        }
      }
    }
  }
}
</style>

